import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import {  formatTimeNoColon } from '../../../helpers/timeHelpers';
import './Trip.scss';
import { getWeekday } from '../../../helpers/dateHelpers';
import { segment } from '../../../models/PairingByIdInterface';
import { useTranslation } from 'react-i18next';

interface summationRowsInterface {
  label: string,
  dayTotal: string | number,
  nightTotal: string | number,
  totalCredits: string | number
}

export default function Trip({ rows=[] as segment[], block, tAllowance, tafb, redeyecredit, isAdgCredit=false, ttgOverSeasDayCredit=0, ttgOverSeasNgtCredit=0, ttgDomesticDayCredit=0, ttgDomesticNgtCredit=0, actualView=false, myBlockMonth=false }) {
  const {t} = useTranslation();
  let summationRows:any = [{} as summationRowsInterface];
  let dayTotal = 0,
    nightTotal = 0,
    totalTotal = 0,
    tDutyTotal = 0,
    dpgDayTotal = 0,
    dpgNightTotal = 0,
    dpgTotalCredits = 0;

  if(rows) {
    rows.forEach((row) => {
      row.total = row.day + row.night;
      row.dayNightDpgSum = (row.hotelSegment[0]?.dpgDayCredit || 0) + (row.hotelSegment[0]?.dpgNightCredit || 0);
      dayTotal = dayTotal + row.day;
      nightTotal = nightTotal + row.night;
      tDutyTotal = tDutyTotal + (row.hotelSegment[0]?.totalDuty || 0);
      
      totalTotal = totalTotal + row.total;
      row.weekday = getWeekday(row.departDate); 
      if(row.hotelSegment.length !== 0) {
        dpgDayTotal = dpgDayTotal + (row.hotelSegment[0]?.dpgDayCredit || 0);
        dpgNightTotal = dpgNightTotal + (row.hotelSegment[0]?.dpgNightCredit || 0);
        dpgTotalCredits = dpgTotalCredits + row.dayNightDpgSum;
      }
      // separate the hotel name and the phone number
      if (!myBlockMonth) {
        let hotelString = row.hotelSegment[0]?.hotel;
        if (hotelString) {
          let phoneIndicator = hotelString.match(/(?:[-+() ]*\d){10,13}/gm);
          if (phoneIndicator) {
            row.hotelSegment[0].hotelName = hotelString.split(phoneIndicator[0])[0] || '';
            row.hotelSegment[0].hotelNumber = hotelString.split(row.hotelSegment[0].hotelName)[1] || '';
          }
          else {
            row.hotelSegment[0].hotelName = hotelString;
          }
        }
      }
    });
  }

  // include redeyecredit with totalTotal
  if(redeyecredit > 0) {
    totalTotal = totalTotal + redeyecredit;
  }

  const hideZero = (num) => {
    return num !== 0? num : ''
  }

  const isShowDpg = (ttgOverSeasDayCredit!==0 || ttgOverSeasNgtCredit!==0 || ttgDomesticDayCredit!==0 || ttgDomesticNgtCredit!==0)? false : true;

  const totalRows = () => {
    if((ttgOverSeasDayCredit===0 && ttgOverSeasNgtCredit===0 && ttgDomesticDayCredit===0 && ttgDomesticNgtCredit===0) && dpgTotalCredits !== 0) {
        summationRows =  [{
          label: `${t('detailsView.dpg')} -`,
          dayTotal: hideZero(formatTimeNoColon(dpgDayTotal)),
          nightTotal: hideZero(formatTimeNoColon(dpgNightTotal)),
          totalCredits: hideZero(formatTimeNoColon(dpgTotalCredits))
        },
        {
          label: `${t('detailsView.total')} -`,
          dayTotal: formatTimeNoColon(dayTotal+dpgDayTotal),
          nightTotal: formatTimeNoColon(nightTotal+dpgNightTotal),
          totalCredits: formatTimeNoColon(totalTotal+dpgTotalCredits)
        }]
    } else if((ttgOverSeasDayCredit!==0 || ttgOverSeasNgtCredit!==0) && (ttgDomesticDayCredit!==0 || ttgDomesticNgtCredit!==0)) {
        summationRows = [{
          label: `${t('detailsView.ttgDom')}`,
          dayTotal: hideZero(formatTimeNoColon(ttgDomesticDayCredit)),
          nightTotal: hideZero(formatTimeNoColon(ttgDomesticNgtCredit)),
          totalCredits: hideZero(formatTimeNoColon(ttgDomesticDayCredit+ttgDomesticNgtCredit))
        },
        {
          label: `${t('detailsView.ttgOvs')}`,
          dayTotal: hideZero(formatTimeNoColon(ttgOverSeasDayCredit)),
          nightTotal: hideZero(formatTimeNoColon(ttgOverSeasNgtCredit)),
          totalCredits: hideZero(formatTimeNoColon(ttgOverSeasDayCredit+ttgOverSeasNgtCredit))
        },
        {
          label: `${t('detailsView.total')} -`,
          dayTotal: formatTimeNoColon(dayTotal+ttgDomesticDayCredit+ttgOverSeasDayCredit),
          nightTotal: formatTimeNoColon(nightTotal+ttgDomesticNgtCredit+ttgOverSeasNgtCredit),
          totalCredits: formatTimeNoColon(totalTotal+ttgDomesticDayCredit+ttgDomesticNgtCredit+ttgOverSeasDayCredit+ttgOverSeasNgtCredit)
        }]
    } else if(ttgDomesticDayCredit!==0 || ttgDomesticNgtCredit!==0) {
        summationRows = [{
          label: `${t('detailsView.ttgDom')}`,
          dayTotal: hideZero(formatTimeNoColon(ttgDomesticDayCredit)),
          nightTotal: hideZero(formatTimeNoColon(ttgDomesticNgtCredit)),
          totalCredits: hideZero(formatTimeNoColon(ttgDomesticDayCredit+ttgDomesticNgtCredit))
        },
        {
          label: `${t('detailsView.total')} -`,
          dayTotal: formatTimeNoColon(dayTotal+ttgDomesticDayCredit),
          nightTotal: formatTimeNoColon(nightTotal+ttgDomesticNgtCredit),
          totalCredits: formatTimeNoColon(totalTotal+ttgDomesticDayCredit+ttgDomesticNgtCredit)
        }]
    } else if(ttgOverSeasDayCredit!==0 || ttgOverSeasNgtCredit!==0) {
        summationRows = [{
          label: `${t('detailsView.ttgOvs')}`,
          dayTotal: hideZero(formatTimeNoColon(ttgOverSeasDayCredit)),
          nightTotal: hideZero(formatTimeNoColon(ttgOverSeasNgtCredit)),
          totalCredits: hideZero(formatTimeNoColon(ttgOverSeasDayCredit+ttgOverSeasNgtCredit))
        },
        {
          label: `${t('detailsView.total')} -`,
          dayTotal: formatTimeNoColon(dayTotal+ttgOverSeasDayCredit),
          nightTotal: formatTimeNoColon(nightTotal+ttgOverSeasNgtCredit),
          totalCredits: formatTimeNoColon(totalTotal+ttgOverSeasDayCredit+ttgOverSeasNgtCredit)
        }]
    } else {
        summationRows = [{
          label: '',
          dayTotal: '',
          nightTotal: '',
          totalCredits: ''
        },
        {
          label: `${t('detailsView.total')} -`,
          dayTotal: formatTimeNoColon(dayTotal),
          nightTotal: formatTimeNoColon(nightTotal),
          totalCredits: formatTimeNoColon(totalTotal)
        }]
    }
  }

  totalRows();
  
  return (
    <>
      <TableContainer className='tripTable'>
        <Table aria-label=''>
          <TableHead>
              <TableRow className='col-heading'>
                <TableCell><span>{t('detailsView.day')}</span></TableCell>
                <TableCell><span>{t('detailsView.dh')}</span></TableCell>
                <TableCell><span>{t('detailsView.fltno')}</span></TableCell>
                <TableCell colSpan={2}><span>{t('detailsView.depart')}</span></TableCell>
                <TableCell colSpan={2}><span>{t('detailsView.arrive')}</span></TableCell>
                {!actualView ? <>
                  <TableCell><span>{t('detailsView.daycredit')}</span></TableCell>
                  <TableCell><span>{t('detailsView.night')}</span></TableCell>
                </> : 
                <>
                  <TableCell className='actualSpan'><span ></span></TableCell>
                  <TableCell className='actualSpan'><span></span></TableCell>
                </>}               
                <TableCell><span>{t('detailsView.total')}</span></TableCell>
                <TableCell><span>{t('detailsView.tduty')}</span></TableCell>
                <TableCell><span>{t('detailsView.layover')}</span></TableCell>
                <TableCell><span>{t('detailsView.hotel')}</span></TableCell>
                <TableCell className='same-line'><span>{t('detailsView.mls')}</span></TableCell>
                {!actualView ? <TableCell align='right'><span>{t('detailsView.all')}</span></TableCell>:''}
              </TableRow>
            </TableHead>
            <TableBody>
            {
              rows && rows.map((row) => (<>
                  <TableRow> 
                    <TableCell>{row.daycount}</TableCell>
                    <TableCell>{row.deadhead? row.carierCode: ''}</TableCell>
                    <TableCell>{row.fltNo}</TableCell>
                    <TableCell>{row.departAirport}</TableCell>
                    <TableCell className={actualView && row.departTimeDeviation ? ( row.departTimeDeviation > 0 ? 'time-deviation-red' : 'time-deviation-green') : 'time-normal'}>{formatTimeNoColon(row.departTime)}</TableCell>
                    <TableCell>{row.arrivalAirport}</TableCell>
                    <TableCell className={actualView && row.arrivalTimeDeviation? ( row.arrivalTimeDeviation > 0 ? 'time-deviation-red' : 'time-deviation-green') : 'time-normal'}>{formatTimeNoColon(row.arrivalTime)}</TableCell>
                  {!actualView ?
                    <>
                      <TableCell className='daycredit-cell'>{hideZero(formatTimeNoColon(row.day))}</TableCell>
                      <TableCell className='nightcredit-cell'>{hideZero(formatTimeNoColon(row.night))}</TableCell>
                    </> : <>
                      <TableCell className='daycredit-cell'></TableCell>
                      <TableCell className='nightcredit-cell'></TableCell>
                    </>}
                    {!myBlockMonth || !actualView ? <TableCell>{formatTimeNoColon(row.total)}</TableCell> : <TableCell>{formatTimeNoColon(row.totalSegmentActual)}</TableCell>}
                    {!myBlockMonth ? <TableCell className='totalDuty-cell'>{row.hotelSegment[0]? hideZero(formatTimeNoColon(row.hotelSegment[0]?.totalDuty)): ''}</TableCell> : <TableCell className='totalDuty-cell'>{row.totalDutySegment ? hideZero(formatTimeNoColon(row.totalDutySegment)):''}</TableCell>}
                    <TableCell colSpan={2}>{row.hotelSegment[0]?.totalLayover? hideZero(formatTimeNoColon(row.hotelSegment[0]?.totalLayover)): ''}</TableCell>
                    <TableCell>{row.mls ?? ''}</TableCell>
                    {!actualView ? <TableCell align='right'> {row.allFlight ?? '' }</TableCell>: ''}
                  </TableRow>
                    {row.hotelSegment.length ? 
                      <TableRow>
                        <TableCell colSpan={7}></TableCell>
                        {!actualView ?
                          <>
                            <TableCell>{isShowDpg ? hideZero(formatTimeNoColon(row.hotelSegment[0]?.dpgDayCredit)) : ''}</TableCell>
                            <TableCell>{isShowDpg ? hideZero(formatTimeNoColon(row.hotelSegment[0]?.dpgNightCredit)) : ''}</TableCell>
                            <TableCell>{isShowDpg ? hideZero(formatTimeNoColon(row.dayNightDpgSum)) : ''}</TableCell>
                            <TableCell colSpan={2} className='dpg-label'>{isShowDpg ? ((!row.hotelSegment[0]?.dpgDayCredit && !row.hotelSegment[0]?.dpgNightCredit)) ? '' : `-${t('detailsView.dpg')}` : ''}</TableCell>
                          </> : <><TableCell></TableCell><TableCell></TableCell><TableCell></TableCell><TableCell></TableCell><TableCell></TableCell></>}
                        <TableCell>{row.hotelSegment[0].hotelName} <span className='same-line'>{row.hotelSegment[0].hotelNumber}</span></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{row.hotelSegment[0]?.allHotel}</TableCell>
                      </TableRow>: ""
                    }
                </>
                ))
            }
            <TableRow className='space-up'>
              <TableCell colSpan={5}></TableCell>
              {!actualView ? <>
                <TableCell colSpan={2} align='right'>{redeyecredit>0? `${t(isAdgCredit ? 'detailsView.adgCreditLabel' : 'detailsView.redEyeCreditLabel')} -` : ''}</TableCell>
                <TableCell align='right' colSpan={2} className='border-top'></TableCell>
                <TableCell align='right' className='border-top'>{redeyecredit > 0 ? formatTimeNoColon(redeyecredit) : ''}</TableCell>
                <TableCell colSpan={2} align='right' className='border-top'></TableCell>
              </> : ''}
              <TableCell colSpan={2} align='right'></TableCell>
              {!actualView ? <TableCell className='border-top' align='right'></TableCell>: ''}
            </TableRow>
            <TableRow>
              <TableCell colSpan={3}>{t('detailsView.blockMvol')}</TableCell>
              <TableCell colSpan={2}>{formatTimeNoColon(block)}</TableCell>
              {!actualView ?
                <>
                  <TableCell colSpan={2} align='right'>{summationRows[0].label}</TableCell>
                  <TableCell>{summationRows[0].dayTotal}</TableCell>
                  <TableCell>{summationRows[0].nightTotal}</TableCell>
                  <TableCell>{summationRows[0].totalCredits}</TableCell>
                  <TableCell colSpan={2}> {formatTimeNoColon(tDutyTotal)}</TableCell>
                  <TableCell colSpan={2} align='right'>{myBlockMonth ? t('myBlockMonth.initialExpenses').toUpperCase() : t('detailsView.totalAllowance')} - $</TableCell>
                  <TableCell align='right'>{parseInt(tAllowance) ? tAllowance : 0.00}</TableCell>
                </>:''}
            </TableRow>
            <TableRow>
              <TableCell colSpan={3}>{t('detailsView.tafbPteb')}</TableCell>
              <TableCell colSpan={2}>{formatTimeNoColon(tafb)}</TableCell>
              {!actualView ?
                <>
                  <TableCell colSpan={2} align='right' rowSpan={2}>{summationRows[1].label}<br /> {summationRows[2]?.label}</TableCell>
                  <TableCell>{summationRows[1].dayTotal}<br /> {summationRows[2]?.dayTotal}</TableCell>
                  <TableCell>{summationRows[1].nightTotal}<br /> {summationRows[2]?.nightTotal}</TableCell>
                  <TableCell>{summationRows[1].totalCredits}<br />{summationRows[2]?.totalCredits}</TableCell>
                  <TableCell colSpan={5} />
                </> : ''}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
